// Helper function to add wrapper to table
function wrapTable(table: HTMLElement, parent: HTMLElement) {
    const breakpoint = 768;
    if (window.innerWidth > breakpoint || parent.classList.contains('usa-table-container--scrollable')) {
        return;
    }
    const wrapper = document.createElement('div');
    wrapper.classList.add('usa-table-container--scrollable');
    wrapper.setAttribute('tabindex', '0');
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);

    const nextSibling = table.nextElementSibling;
    if (nextSibling && nextSibling.getAttribute('aria-live')) {
        wrapper.appendChild(nextSibling);
    }
}

// Helper function to remove wrapper from table
function unwrapTable(table: HTMLElement, parent: HTMLElement) {
    const breakpoint = 768;
    if (window.innerWidth <= breakpoint || !parent.classList.contains('usa-table-container--scrollable')) {
        return;
    }
    const wrapperParent = parent.parentNode;
    if (wrapperParent) {
        wrapperParent.insertBefore(table, parent);

        const nextSibling = parent.querySelector('[aria-live]');
        if (nextSibling){
            wrapperParent.insertBefore(nextSibling, parent);
        }

        wrapperParent.removeChild(parent);
    }
}

function adjustTableForResponsive() {
    const tables = document.querySelectorAll('.usa-table--sortable');
    tables.forEach((table: Element) => {
        if (!(table instanceof HTMLElement) || !(table.parentNode instanceof HTMLElement)) {
            return;
        }

        const parent = table.parentNode as HTMLElement;
        wrapTable(table, parent);
        unwrapTable(table, parent);
    });
}

// Initial check
adjustTableForResponsive();

// Add event listener for window resize
window.addEventListener('resize', adjustTableForResponsive);
